import { Flex } from "@mantine/core";
import InviteStats from "./InviteStats";
import RecipientsTable from "./RecipientsTable";
import { useGetInviteStats } from "../../../api/invites";

// Invitees tab: delivery stats + the recipients table. Import is triggered from
// the page-level action bar (next to Export). Self-contained (takes eventId).
const Invitees = ({ eventId }) => {
  const { data: stats } = useGetInviteStats(eventId);

  return (
    <Flex direction="column" gap="lg">
      <InviteStats stats={stats} />
      <RecipientsTable eventId={eventId} />
    </Flex>
  );
};

export default Invitees;
